export default __webpack_public_path__ + "static/media/04.db2e2d20.jpg";